import { format, getTime, formatDistanceToNow } from 'date-fns';

export function fDate(date: Date | string | number | null) {
  return date !== null ? format(new Date(date), 'dd.MM.yyyy') : '';
}

export function fDateTime(date: Date | string | number | null) {
  return date !== null ? format(new Date(date), 'dd.MM.yyyy p') : '';
}

export function fTimestamp(date: Date | string | number) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date: Date | string | number) {
  return format(new Date(date), 'yyyy/MM/dd hh:mm p');
}

export function fDateTime24(date: Date | string | number) {
  return format(new Date(date), 'dd.MM.yyyy HH:mm');
}

export function fDateTime24withSeconds(date: Date | string | number) {
  return format(new Date(date), 'dd.MM.yyyy HH:mm:ss');
}

export function fDateServer(date: Date | string | number) {
  return format(new Date(date), 'yyyy-MM-dd');
}

export function fDateTimeServer(date: Date | string | number) {
  return format(new Date(date), 'yyyy-MM-dd HH:mm:ss');
}

export function fDateToMoscow(date: Date) {
  return new Date(date.toLocaleString('en-US', { timeZone: 'Europe/Moscow' }));
}

export function fDateFromMoscow(date: string) {
  // some date have format like 'yyyy-dd-MMTHH:mm:ss.00000Z'
  // in this case we just need to use new Date
  // otherwise we need to convert date from moscow timezone
  const isDateString = date?.includes('Z') && date?.includes('T');

  if (isDateString) return new Date(date);

  const moscowDate = new Date(date);

  const moscowOffset = 180;

  const localOffset = new Date().getTimezoneOffset();

  const offsetDiff = moscowOffset + localOffset;

  return new Date(moscowDate.getTime() - offsetDiff * 60000); // 60000 milliseconds in a minute
}

export function fToNow(date: Date | string | number) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export const formatUtcToMoscow = (value: string) =>
  new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Europe/Moscow',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23',
  })
    .format(new Date(value))
    .replace(',', '');
